module.exports = __webpack_public_path__ + "static/img/chairman.630d739.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/chairman.png
// module id = ngJA
// module chunks = 1